export const getSession = name => {
  return getVal(name);
};

const getVal = name => {
  var value = null;
  var vars = sessionStorage.getItem(name);
  if (vars !== "" && vars) {
    value = JSON.parse(vars);
  } else {
    value = vars;
  }
  return value;
};

export const setSession = (name, obj) => {
  var value = JSON.stringify(obj);
  if (value === "" || value === "{}" || value === "[]" || !value) {
    value = "";
  }
  sessionStorage.setItem(name, value);
};
const random_string = len => {
  len = len || 32;
  var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  var maxPos = chars.length;
  var pwd = "";
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  pwd += new Date().getTime();
  return pwd;
};

const uploadOssFile = file => {
  let list = ["png", "jpg", "jpeg", "bmp", "gif", "webp", "psd", "svg", "tiff"];
  try {
    let name = file.name;
    let index = name.lastIndexOf(".");
    let ext = name.substr(index + 1);
    if (list.indexOf(ext.toLowerCase()) !== -1) {
      return ext;
    } else {
      Toast.fail("文件格式错误");
      return false;
    }
  } catch (e) {
    console.log(e);
    Toast.fail("文件格式错误");
    return false;
  }
};

const Ajax = require("./ajax");
import { uploadOssUrl, ossBaseUrl } from "@/config/env.js";

export const uploadOss = (file, suc) => {
  let loadingToast = Toast.loading({
    duration: 0,
    message: "加载中...",
    forbidClick: true,
    loadingType: "spinner"
  });
  let ext = uploadOssFile(file);
  if (!ext) {
    loadingToast.clear();
    return;
  }
  const params = {
    url: "/manage/common/webSignature",
    dataType: "json",
    success: res => {
      console.log(res);
      if (res.data) {
        const { accessid, expire, policy, signature } = res.data;
        const host = uploadOssUrl + "/";
        const expirenum = parseInt(expire);
        var formData = new FormData();
        var img = "image/" + random_string(10) + "." + ext;
        formData.append("name", img);
        formData.append("key", img);
        formData.append("policy", policy);
        formData.append("OSSAccessKeyId", accessid);
        formData.append("success_action_status", 200);
        formData.append("signature", signature);
        formData.append("file", file);
        var request = new XMLHttpRequest();
        request.open("POST", host);
        request.send(formData);
        request.onreadystatechange = function() {
          if (request.readyState == 4 && request.status == 200) {
            suc(ossBaseUrl + "/" + img);
            loadingToast.clear();
          }
        };
      }
    }
  };
  Ajax.default(params);
};

export const dateFormat = (tmp, fmt) => {
  let date = null;
  if (!tmp) {
    return "";
  }
  // 统一东八区
  let oft = new Date().getTimezoneOffset() / 60;
  let t = new Date(tmp).getTime() + oft * 60 * 60 * 1000 + 8 * 60 * 60 * 1000;

  if (tmp instanceof Date) {
    date = new Date(t);
  } else if (typeof tmp == "string" || typeof tmp == "number") {
    date = new Date(t);
  } else {
    return "";
  }
  if (date == "Invalid Date") {
    let aaa = tmp.replace(/-/g, "/");
    // 统一东八区
    let ab =
      new Date(aaa).getTime() + oft * 60 * 60 * 1000 + 8 * 60 * 60 * 1000;
    date = new Date(ab);
  }
  if (!fmt) {
    fmt = "yyyy-MM-dd";
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
  // 'yyyy-MM-dd hh:mm:ss'
  //'yyyy年MM月dd日'
};

export const init = () => {
  if (process.browser) {
    if (
      window.navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      document.documentElement.classList.add("mobile");
      let idealViewWidth = document.body.clientWidth;
      const BASICVALUE = 750;
      if (idealViewWidth < 320) {
        idealViewWidth = 320;
      }
      let fontSize = (idealViewWidth / BASICVALUE) * 100 + "px";
      document.documentElement.style.fontSize = fontSize;
    } else {
      document.documentElement.classList.remove("mobile");
      document.documentElement.style.fontSize = "14px";
    }
  }
};

// 转拼音

import { pinyin } from "./const.js";

const arraySearch = (l1, l2) => {
  for (var name in pinyin) {
    if (pinyin[name].indexOf(l1) !== -1) {
      return ucfirst(name);
    }
  }
  return false;
};

const ucfirst = l1 => {
  if (l1.length > 0) {
    var first = l1.substr(0, 1).toUpperCase();
    var spare = l1.substr(1, l1.length);
    return first + spare;
  }
};

export const chineseToPinYin = l1 => {
  var l2 = l1.length;
  var I1 = "";
  var reg = new RegExp("[a-zA-Z0-9]");
  for (var i = 0; i < l2; i++) {
    var val = l1.substr(i, 1);
    var name = arraySearch(val, pinyin);
    if (reg.test(val)) {
      I1 += val;
    } else if (name !== false) {
      I1 += name;
    }
  }
  I1 = I1.replace(/ /g, "-");
  while (I1.indexOf("--") > 0) {
    I1 = I1.replace("--", "-");
  }
  return I1;
};



// WEBPACK FOOTER //
// ./src/util/util.js